export const AGENT_VISIBILITY_VALUES = [
  'private',
  'public',
  'archived',
] as const;

export type AgentVisibility = (typeof AGENT_VISIBILITY_VALUES)[number];

export const AGENT_VISIBILITY_LABELS: Record<AgentVisibility, string> = {
  private: 'Private',
  public: 'Public',
  archived: 'Archived',
};
